// Selecting Elements
const player0El = document.querySelector('.player--0');
const player1El = document.querySelector('.player--1');
const score0El = document.querySelector('#score--0');
const score1El = document.getElementById('score--1');
const current0El = document.getElementById('current--0');
const current1El = document.getElementById('current--1');
const diceEl = document.querySelector('.dice');
const btnNew = document.querySelector('.btn--new');
const btnRoll = document.querySelector('.btn--roll');
const btnHold = document.querySelector('.btn--hold');

//import images
import dice1 from '../images/dice-1.png';
import dice2 from '../images/dice-2.png';
import dice3 from '../images/dice-3.png';
import dice4 from '../images/dice-4.png';
import dice5 from '../images/dice-5.png';
import dice6 from '../images/dice-6.png';

// Starting Conditions
let scores, currentScore, activePlayer, playing;

const init = function () {
  scores = [0, 0];
  currentScore = 0;
  activePlayer = 0;
  playing = true;

  score0El.textContent = 0;
  score1El.textContent = 0;
  current0El.textContent = 0;
  current1El.textContent = 0;

  diceEl.classList.add('hidden');
  player0El.classList.remove('player--winner');
  player1El.classList.remove('player--winner');
  player1El.classList.remove('player--active');
  player0El.classList.add('player--active');
};
init();

const switchPlayer = function () {
  currentScore = 0;
  document.getElementById(`current--${activePlayer}`).textContent = 0;
  activePlayer = activePlayer === 0 ? 1 : 0;
  player0El.classList.toggle('player--active');
  player1El.classList.toggle('player--active');
};

// Rolling Dice Functionality
btnRoll.addEventListener('click', function () {
  if (playing) {
    // 1 Generate random dice roll
    const dice = Math.trunc(Math.random() * 6) + 1;
    // 2 Display Roll
    diceEl.classList.remove('hidden');

    let diceSrc;
    switch (dice) {
      case 1:
        diceSrc = dice1;
        break;
      case 2:
        diceSrc = dice2;
        break;
      case 3:
        diceSrc = dice3;
        break;
      case 4:
        diceSrc = dice4;
        break;
      case 5:
        diceSrc = dice5;
        break;
      case 6:
        diceSrc = dice6;
        break;
      default:
        diceSrc = ''; // Handle default case
    }
    diceEl.src = diceSrc;
    // 3 Check for a roll of 1
    if (dice !== 1) {
      // Not a 1, add to score
      currentScore += dice;
      document.getElementById(`current--${activePlayer}`).textContent =
        currentScore;
    } else {
      // if true switch to next player
      switchPlayer();
    }
  }
});

btnHold.addEventListener('click', function () {
  if (playing) {
    // 1 Add current score to active player's score
    scores[activePlayer] += currentScore;
    document.getElementById(`score--${activePlayer}`).textContent =
      scores[activePlayer];
    // 2 Check if player's score is >= 100
    if (scores[activePlayer] >= 100) {
      // 3 Finish the game
      playing = false;
      diceEl.classList.add('hidden');
      document
        .querySelector(`.player--${activePlayer}`)
        .classList.add('player--winner');
      document
        .querySelector(`.player--${activePlayer}`)
        .classList.remove('player--active');
    } else {
      // 4 Switch to next player
      switchPlayer();
    }
  }
});

// Reset
btnNew.addEventListener('click', init);
